import Navlink from "../../component/navlink/Navlink";

const MainIfas = ({ children }) => {
  return (
    <>
      <Navlink />
      {children}
    </>
  );
};

export default MainIfas;
